/** The guide piece's behavior half: reads the studio's guide and heading. Draws nothing. */
import { useMemo } from 'react';

import { useSiteStudio } from '../../api/site';
import { usePieceOptions, type PieceInput, type PieceRuntime } from '../../contract/runtime';
import { contract, type GuideActions, type GuideEvents, type GuideState } from './contract';

export type GuideRuntime = PieceRuntime<typeof contract, GuideState, GuideActions>;

const NO_ACTIONS: GuideActions = {};

export function useGuide(input: PieceInput<GuideEvents> = {}): GuideRuntime {
  const options = usePieceOptions(contract, input.options);
  const query = useSiteStudio();
  const studio = query.data;
  const guide = studio?.guide ?? null;

  const bio = useMemo(
    () =>
      (guide?.bio ?? '')
        .split(/\n\s*\n/)
        .map((p) => p.trim())
        .filter(Boolean),
    [guide?.bio],
  );
  const status: GuideState['status'] = studio ? 'ready' : query.isError ? 'error' : 'loading';

  return {
    state: {
      status,
      heading: studio?.guideHeading ?? '',
      name: guide?.name?.trim() || null,
      photoUrl: guide?.photoUrl ?? null,
      role: guide?.role?.trim() || null,
      credentials: guide?.credentials?.trim() || null,
      bio,
      followsStory: Boolean(studio?.story?.trim()),
    },
    actions: NO_ACTIONS,
    options,
  };
}
